import React from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {theme} from "../../../../shared/theme";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles({
    iconGrid: {
        "& > *":{
            width: "40px",
            height: "40px",
            margin: "0 1.25em 0 0",
            "& path" : {
                fill: "#f2a800"
            }
        }
    },
    container: {
        backgroundColor: "#fdf2e3",
        padding: theme.spacing(2)
    },
    textColor: {
        color: "#663c00"
    }
});

const PremiumNotification = (props) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Grid container className={classes.container} alignItems={"center"}>
                <Grid item xs={12} sm={1} md={1} className={classes.iconGrid}>
                    {props.icon}
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12}>
                            <Typography variant={"subtitle2"} color={"secondary"}>
                                {props.title}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Typography variant={"caption"} className={classes.textColor}>
                                {props.message}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={2} md={1}>
                    <Button variant={"text"} color={"secondary"} onClick={props.onClick}>
                        {props.buttonText}
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default PremiumNotification;
